import { OrderPriceModifier } from '__generated__/atlas-types'

import { FinancialSummaryTestIds } from '../FinancialSummaryWidget'
import { ConceptText, NumericText, Row } from '../FinancialSummaryWidget.ui'

const CustomFees = ({
  customFees,
  currencyCode,
  disabled,
}: {
  customFees: OrderPriceModifier[]
  currencyCode: string
  disabled?: boolean
}) => {
  return (
    <>
      {customFees.map((customFee) => (
        <Row
          style={{ marginTop: '5px' }}
          key={`${customFee.name}-${customFee.percentageAmount}`}
        >
          <ConceptText className={disabled ? 'disabled' : 'light'}>
            {customFee.name}
          </ConceptText>
          <NumericText id={FinancialSummaryTestIds.CustomFeeAmount}>
            {`${customFee.percentageAmount}%
                        (${currencyCode} +${customFee.factor})`}
          </NumericText>
        </Row>
      ))}
    </>
  )
}

export default CustomFees
